import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01185f15"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile" }

import {nextTick, reactive, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'mobileView',
  props: {
    mobile: {
        type: String,
        default: ""
    },
},
  setup(__props) {

const props = __props;


watch(
    () => props.mobile, async () => {
        await nextTick(()=>{
            data.mobileData = props.mobile;
        })
    },
    {
        immediate: true,
        deep: true,
    }
);
const data = reactive({
    mobileData: ""
})

return (_ctx: any,_cache: any) => {
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (data.mobileData)
    ? (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 0,
        content: "点击复制"
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", _hoisted_1, [
            _createTextVNode(_toDisplayString(data.mobileData) + " ", 1),
            _createVNode(_component_CopyOutlined, { style: {"color":"#CCC"} })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})